import { isProduction } from 'config/constants';

export const isNotificationsEnabled = !isProduction;
